import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
  const store = createStore(rootReducer,
                            composeEnhancers(applyMiddleware(thunk)));
  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js